import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * Label Component
 * Apple-inspired form label with refined typography
 * Follows design tokens from tokens.css
 */
const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "text-sm font-medium leading-tight text-app-text peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
      className
    )}
    {...props}
  />
))
Label.displayName = "Label"

export { Label }
